import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-preview-survey-star-rating',
  templateUrl: './preview-survey-star-rating.component.html',
  styleUrls: ['./preview-survey-star-rating.component.scss']
})
export class PreviewSurveyStarRatingComponent {

  numberOfStar: any
  constructor(public sanitizer: DomSanitizer) { }
  @Input() questions: any;
  @Input() isReadOnly: boolean;
  @Input() displayMode: string;
  @Input() set numberOfStarList(data: any) {
    if (data && data.length) {
      this.numberOfStar = data[0].optionId;
    }
  };

}
